import styles from './DevicesSelector.module.scss'

import { useEffect, useState } from 'react'

import { orderSystemsGroupType } from 'common/functions/orderSystems'
import { Checkbox } from '../../Atoms/Checkbox/Checkbox'
import { CollapseIcon } from 'icons/CollapseIcon/CollapseIcon'

export const DeviceSelector = ({
  translate,
  selectedCheckboxIds,
  setSelectedCheckboxIds,
  systems,
  userWriting,
  checkboxColor
}) => {
  const [open, setOpen] = useState({})

  const [systemsByGroup, setSystemsByGroup] = useState([])

  const orderSystemsByGroup = () => {
    const grouped = orderSystemsGroupType(systems)
    const { undefined: unassignedSystems, ...assignedSystems } = grouped

    const systemsByGroup = { ...assignedSystems }
    if (unassignedSystems) {
      systemsByGroup[translate('noGroup')] = unassignedSystems
    }

    setSystemsByGroup(systemsByGroup)
  }

  const handleClick = key => {
    const openKey = open[key]
    setOpen({ ...open, [key]: !openKey })
  }

  const isChecked = systemId => {
    return selectedCheckboxIds.some(selectedId => selectedId === systemId)
  }

  const onSelectAllSystemsClick = value => {
    if (selectedCheckboxIds.includes(value)) {
      setSelectedCheckboxIds([])
      return
    }
    const systemIds = systems.map(system => {
      return system._id
    })
    systemIds.push(value)
    // cogemos todos los grupos
    const groupIds = Object.keys(systemsByGroup)

    groupIds.forEach(group => {
      const groupSystems = systemsByGroup[group]
      const groupTypeIds = Object.keys(groupSystems)
      groupTypeIds.forEach(type => {
        const groupTypeKey = `${group}-${type}`
        systemIds.push(groupTypeKey) // añadimos los tipos de sistemas del grupo
      })
    })

    systemIds.push(...groupIds) // añadimos los grupos al array

    setSelectedCheckboxIds(systemIds)
  }

  const onSelectGroupTypeClick = (groupType, name, groupName) => {
    const groupTypeIds = groupType.map(system => system._id)
    if (selectedCheckboxIds.includes(name)) {
      const idsToRemove = new Set([...groupTypeIds, name]) // name + groupIds en un solo Set
      if (groupName) idsToRemove.add(groupName) // Si hay un groupName, lo añadimos al Set
      const newArray = selectedCheckboxIds.filter(id => !idsToRemove.has(id)) // elimina ambos

      // Quitar 'SELECT_ALL' si sigue presente
      const finalArray = newArray.includes('SELECT_ALL')
        ? newArray.filter(id => id !== 'SELECT_ALL')
        : newArray

      setSelectedCheckboxIds(finalArray)
    } else {
      if (name) groupTypeIds.push(name)
      const updatedSet = new Set([...selectedCheckboxIds, ...groupTypeIds])
      const updateSetFormated = Array.from(updatedSet)
      setSelectedCheckboxIds(updateSetFormated)
    }
  }

  const updateSelectedSystems = (systemId, currentGroupType, currentGroup) => {
    const getNewSelectedSystems = currentSelectedSystems => {
      if (currentSelectedSystems.includes(systemId)) {
        // Armamos un Set con los elementos a eliminar (más eficiente que un array y el el has de despues es mejor que el includes)
        const idsToRemove = new Set([systemId])
        if (currentGroupType) idsToRemove.add(currentGroupType)
        if (currentGroup) idsToRemove.add(currentGroup)

        // Quitamos `systemId` y, cuando aplique, `currentGroupType`
        let newArray = currentSelectedSystems.filter(id => !idsToRemove.has(id))

        // Si quedó 'SELECT_ALL', lo eliminamos también
        if (newArray.includes('SELECT_ALL')) {
          newArray = newArray.filter(id => id !== 'SELECT_ALL')
        }

        return newArray
      } else {
        // Crear un nuevo array con el elemento seleccionado
        const newArray = [...currentSelectedSystems, systemId]
        return newArray
      }
    }
    const newSelectedSystems = getNewSelectedSystems(selectedCheckboxIds)
    setSelectedCheckboxIds(newSelectedSystems)
  }

  const onSelectGroupClick = (groupObj, groupName) => {
    //  Sacamos los sistemas que pertenecen al grupo elegido
    const allGroupIds = Object.values(groupObj)
      .flat() // convierte en un solo array de sistemas
      .map(system => system._id) // array de _id

    const typeIds = Object.keys(groupObj) // tipos de sistemas del grupo
    const formatedTypeIds = typeIds.map(type => `${groupName}-${type}`) // formateamos los tipos

    //  ¿El grupo ya está seleccionado? -> lo quitamos
    if (selectedCheckboxIds.includes(groupName)) {
      const idsToRemove = new Set([...allGroupIds, groupName, ...formatedTypeIds]) // groupKey + todos los IDs
      let newArray = selectedCheckboxIds.filter(id => !idsToRemove.has(id))

      //  Quitamos SELECT_ALL si quedó vivo
      if (newArray.includes('SELECT_ALL')) {
        newArray = newArray.filter(id => id !== 'SELECT_ALL')
      }

      setSelectedCheckboxIds(newArray)
      return
    }

    //  El grupo NO estaba seleccionado -> lo añadimos
    const idsToAdd = [...allGroupIds, groupName, ...formatedTypeIds] // IDs + propio nombre del grupo
    const updated = new Set([...selectedCheckboxIds, ...idsToAdd]) // sin duplicados
    setSelectedCheckboxIds([...updated])
  }

  const getGroupData = (group, groupName) => {
    if (group === undefined) {
      return null
    }
    return Object.keys(group).map(type => {
      const typeId = `${groupName}-${type}`
      return (
        <div
          key={typeId}
          className={styles.typeListContainer}
        >
          <div className={styles.typeListItem}>
            <CollapseIcon
              open={userWriting ? true : open[typeId]}
              onClick={() => handleClick(typeId)}
            />
            <Checkbox
              value={typeId}
              label={translate(type)}
              onChange={() => onSelectGroupTypeClick(group[type], typeId, groupName)}
              isChecked={isChecked(typeId)}
              color={checkboxColor}
            />
          </div>
          <div
            className={styles.micaItemsContainer}
            style={(userWriting ? true : open[typeId]) ? { display: 'block' } : { display: 'none' }}
          >
            {group[type].map((system, index) => {
              return (
                <div
                  key={('Mica ItemCheckbox', index)}
                  className={styles.micaItem}
                >
                  <Checkbox
                    value={system._id}
                    label={system.name}
                    onChange={() => updateSelectedSystems(system._id, typeId, groupName)}
                    isChecked={isChecked(system._id)}
                    color={checkboxColor}
                  />
                </div>
              )
            })}
          </div>
        </div>
      )
    })
  }

  useEffect(() => {
    orderSystemsByGroup()
  }, [systems])

  return (
    <div className={styles.deviceListContent}>
      {systems.length > 0 && (
        <div
          className={styles.selectAllContainer}
          key={'selectAllContainer'}
        >
          <Checkbox
            value={'SELECT_ALL'}
            label={translate('selectAll')}
            onChange={() => onSelectAllSystemsClick('SELECT_ALL')}
            isChecked={isChecked('SELECT_ALL')}
            color={checkboxColor}
          />
        </div>
      )}
      <div className={styles.groupsContainer}>
        {Object.keys(systemsByGroup).map(group => {
          return (
            <div key={group}>
              <div className={styles.groupListItem}>
                <CollapseIcon
                  open={userWriting ? true : open[group]}
                  onClick={() => handleClick(group)}
                />
                <Checkbox
                  value={group}
                  label={group}
                  onChange={() => onSelectGroupClick(systemsByGroup[group], group)}
                  isChecked={isChecked(group)}
                  color={checkboxColor}
                />
              </div>
              <div
                style={
                  (userWriting ? true : open[group]) ? { display: 'block' } : { display: 'none' }
                }
              >
                {getGroupData(systemsByGroup[group], group)}
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
